



















import { Component, Prop, Vue } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { options } from '@core/model/UIOptions'
import { ScheduleTimeRequestDto } from './model/ScheduleTimeRequestDto'
import { ScheduleTime } from './model/ScheduleTime'
import { IDateService } from '@master/services/IDateService'

/**
 * In the future, can combine this section with employee benefit's detail section
 * but I just create for the sake of time
 */
@Component({
  components: {
    AppForm
  }
})
export default class ScheduleDetailSection extends Vue {
  @Prop({ default: {} }) schedule: ScheduleTime
  @Prop({ default: () => [] }) frequencyOptions: options[]
  @Prop({ default: {} }) dateService: IDateService
  @Prop({ default: {} }) private tasksNiceName: {}

  get isDisabled () {
    // Remove anything related to store
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  get nextJobDate () {
    if (!this.schedule.enable) {
      return null
    }

    return this.dateService.format(this.schedule.next, 'DD/MM/YYYY')
  }

  get nextJobTime () {
    if (!this.schedule.enable) {
      return null
    }

    return this.dateService.format(this.schedule.next, 'hh:mm A')
  }

  /* eslint-disable @typescript-eslint/camelcase */
  get scheduleStructure (): FormStructure<ScheduleTimeRequestDto> {
    return [
      {
        label: 'Enable Schedule',
        key: 'enable',
        type: 'single-checkbox',
        disabled: this.isDisabled
      },
      {
        label: 'Task Name',
        model: {
          get: () => this.tasksNiceName[this.schedule.name],
          set: (val) => {
            // Do not need to add any values
          }
        },
        disabled: true
      },
      {
        label: 'Select Time',
        key: 'time',
        type: 'time',
        disabled: this.isDisabled
      },
      {
        label: 'Frequency',
        key: 'frequency',
        options: this.frequencyOptions,
        disabled: this.isDisabled
      },
      {
        label: 'Email to',
        key: 'email',
        disabled: this.isDisabled
      },
      {
        label: 'CC to',
        key: 'ccEmail',
        disabled: this.isDisabled
      }
    ]
  }
}
